import React from "react";
import PropTypes from "prop-types";
import { Card, Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

function InfoGeneralCard({ proceso }) {
  const formatDate = (value) => {
    if (!value) return "No tiene.";
    return new Date(value).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };
  const formatDateWithTime = (value) => {
    if (!value) return "No tiene.";
    const fecha = new Date(value);
    return fecha.toLocaleString("es-ES", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SuiBox p={1.5} display="flex" flexDirection="column" height="100%">
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={6}>
            <SuiTypography variant="h6" fontWeight="light">
              Sede:
            </SuiTypography>
            <SuiTypography>{proceso.sede_detalle?.nombre || ""}</SuiTypography>
          </Grid>
          <Grid size={3}>
            <SuiTypography variant="h6" fontWeight="light">
              Asesor(a):
            </SuiTypography>
            <SuiTypography>{proceso.resp_asesor_detalle?.nombre_completo || ""}</SuiTypography>
          </Grid>
          <Grid size={3}>
            <SuiTypography variant="h6" fontWeight="light">
              Operador(a):
            </SuiTypography>
            <SuiTypography>{proceso.resp_operador_detalle?.nombre_completo || ""}</SuiTypography>
          </Grid>
        </Grid>
        <Divider sx={{ my: 0.25 }} />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={3}>
            <SuiTypography variant="h6" fontWeight="light">
              Fecha Admisión:
            </SuiTypography>
            <SuiTypography fontWeight="bold">{formatDate(proceso.fecha_admision)}</SuiTypography>
          </Grid>
          <Grid size={3}>
            <SuiTypography variant="h6" fontWeight="light">
              Fecha Aceptación:
            </SuiTypography>
            <SuiTypography fontWeight="bold">{formatDate(proceso.fecha_aceptacion)}</SuiTypography>
          </Grid>
          <Grid size={3}>
            <SuiTypography variant="h6" fontWeight="light">
              Fecha Designación:
            </SuiTypography>
            <SuiTypography fontWeight="bold">{formatDate(proceso.fecha_designacion)}</SuiTypography>
          </Grid>
          <Grid size={3}>
            <SuiTypography variant="h6" fontWeight="light">
              Fecha Radicación:
            </SuiTypography>
            <SuiTypography fontWeight="bold">{formatDate(proceso.fecha_validacion)}</SuiTypography>
          </Grid>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={6}>
            <SuiTypography variant="h6" fontWeight="light">
              Prox. Audiencia:
            </SuiTypography>
            <SuiTypography fontWeight="bold">
              {formatDateWithTime(proceso.fecha_proxima_audiencia)}
            </SuiTypography>
          </Grid>
          <Grid size={6}>
            <SuiTypography variant="h6" fontWeight="light">
              Ult. Actualización:
            </SuiTypography>
            <SuiTypography fontWeight="bold">
              {formatDateWithTime(proceso.fecha_modificacion)}
            </SuiTypography>
          </Grid>
        </Grid>
        <Divider sx={{ my: 0.25 }} />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={12}>
            <SuiTypography variant="h5" fontWeight="bold">
              Causas de Cesación de no Pago:{" "}
              <SuiTypography component="span">{proceso.causas || ""}</SuiTypography>
            </SuiTypography>
          </Grid>
        </Grid>
        <Divider sx={{ my: 0.25 }} />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={4}>
            <SuiTypography variant="h5" fontWeight="bold">
              Apoderado Cliente:{" "}
              <SuiTypography component="span">
                {proceso.apoderado?.nombre_completo || ""}
              </SuiTypography>
            </SuiTypography>
          </Grid>
          <Grid size={4}>
            <SuiTypography variant="h5" fontWeight="bold">
              Email:{" "}
              <SuiTypography component="span">{proceso.apoderado?.email || ""}</SuiTypography>
            </SuiTypography>
          </Grid>
          <Grid size={4}>
            <SuiTypography variant="h5" fontWeight="bold">
              Celular:{" "}
              <SuiTypography component="span">{proceso.apoderado?.celular || ""}</SuiTypography>
            </SuiTypography>
          </Grid>
        </Grid>
      </SuiBox>
    </Card>
  );
}

InfoGeneralCard.propTypes = {
  proceso: PropTypes.object.isRequired,
};

export default InfoGeneralCard;
